import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Logo_Digital_Life.png")